module.exports = __webpack_public_path__ + "img/team.c57e8e02.jpg";